(() => {
  window.totalBlockingTime = 0;

  if (window.PerformanceObserver) {
    try {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          window.totalBlockingTime += entry.duration - 50;
        });
      });
      observer.observe({ type: 'longtask', buffered: true });
    } catch (e) {
      // noop;
    }
  }

  const whenActivated = new Promise((resolve) => {
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', resolve);
    } else {
      resolve();
    }
  });

  let totalBlockingTimeWhenfirstScriptActivated;

  const lazyScriptActivate = (callback, timeout) => {
    // When a device is so underpowered we don't activate the script at all
    if (navigator.deviceMemory && navigator.deviceMemory < 4) {
      console.info('Device has less than 4GB of memory, not initializing lazy scripts');
      return;
    }

    if (typeof totalBlockingTimeWhenfirstScriptActivated === 'undefined') {
      totalBlockingTimeWhenfirstScriptActivated = window.totalBlockingTime;
    }

    if (totalBlockingTimeWhenfirstScriptActivated > 2000) {
      console.info('Device was already blocked for more than 2 seconds at the start, not initializing lazy scripts');
      return;
    }

    whenActivated
      .then(() => {
        window.requestIdleCallback(callback, {
          timeout,
        });
      })
      .catch(console.info);
  };

  window.swinger = window.swinger || {};
  window.swinger.lazyScriptActivate = lazyScriptActivate;
})();
